var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('cat',{attrs:{"open":_vm.open,"counter":_vm.counter,"bot":_vm.bot}}),_c('Footer',{attrs:{"accumulator":_vm.accumulator,"location":_vm.location}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }